import { useMemo } from "react";
import {
  MAX_DOC_DESCRIPTION,
  MAX_DOC_NAME,
} from "../../../../../../../lib/constants";
import { Rule } from "antd/es/form";

export const useRules = () => {
  const dateRule: Rule[] = useMemo(
    () => [
      {
        required: true,
        validateTrigger: "onSubmit",
        type: "date",
      },
    ],
    [],
  );

  const nameRule: Rule[] = useMemo(
    () => [
      {
        required: true,
        validateTrigger: "onSubmit",
      },
      {
        max: 100,
        message: MAX_DOC_NAME,
        validateTrigger: "onSubmit",
      },
    ],
    [],
  );

  const descriptionRule: Rule[] = useMemo(
    () => [
      {
        max: 300,
        message: MAX_DOC_DESCRIPTION,
        validateTrigger: "onSubmit",
      },
    ],
    [],
  );

  return { dateRule, nameRule, descriptionRule };
};
